import _ from 'lodash';

// Subtract function only returns the extra fields that exists on the minuend and not on the subtrahend.
// If there are modified fields then they are returned as well.
const subtract = ({ minuend, subtrahend }) => {
    const response = {};

    if (!minuend) {
        throw new Error('Minuend is not defined');
    }

    if (_.isEqual(minuend, subtrahend)) {
        return response;
    }

    if (subtrahend === undefined) {
        return minuend;
    }

    if (getType(minuend) !== 'object' || getType(subtrahend) !== 'object') {
        throw new Error('Minuend and subtrahend must be JSON objects');
    }

    for (const [key, value] of Object.entries(minuend)) {
        if (getType(value) === 'object') {
            const subtracted = subtract({ minuend: value, subtrahend: subtrahend?.[key] });
            if (Object.keys(subtracted).length > 0) {
                response[key] = subtracted;
            }
        }
        else if (!valuesAreEqual(value, subtrahend?.[key])) {
            response[key] = value;
        }
    }

    return response;
}

const valuesAreEqual = (value1, value2) => {
    if (getType(value1) === 'function' && String(value1) !== String(value2)) {
        return false;
    }

    if (value1 === undefined && value2 === undefined) {
        return true;
    }

    if (value1 === undefined || value2 === undefined) {
        return false;
    }

    if (JSON.stringify(value1) !== JSON.stringify(value2)) {
        return false;
    }

    return true;
}

const getType = (value) => {
    if (value === null) {
        return 'null';
    }

    if (typeof value === 'number') {
        return 'number';
    }

    if (typeof value === 'boolean') {
        return 'boolean';
    }

    if (typeof value === 'string') {
        return 'string';
    }

    if (value instanceof Boolean) {
        return 'boolean';
    }

    if (value instanceof String) {
        return 'string';
    }

    if (value instanceof Number) {
        return 'number';
    }

    if (value instanceof Function) {
        return 'function';
    }

    if (value instanceof Array) {
        return 'array';
    }

    if (value instanceof Object) {
        return 'object';
    }

    return 'undefined';
}

const isJsonString = (string) => {
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;
}

const deepMerge = (target, source) => {
    if (source === null) {
        return null;
    }

    const result = { ...target };

    Object.keys(source).forEach((key) => {
        if (isObject(target[key])) {
            result[key] = deepMerge(target[key], source[key]);
        }
        else {
            result[key] = source[key];
        }
    });

    return result;
};

const isObject = (obj) => {
    return obj != null && typeof obj === 'object' && !(obj instanceof Array);
}

const JsonHelper = {
    deepMerge,
    subtract,
    isJsonString
}

export default JsonHelper;